import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// "ResizeObserver loop completed with undelivered notifications" —
// brauzerning zararsiz ogohlantirishi (recharts kabi kutubxonalar
// ResponsiveContainer ishlatganda chiqadi). Haqiqiy xato emas, lekin
// CRA dev-error-overlay buni to'liq ekranli xato qilib ko'rsatadi —
// shu xabarni bostirib qo'yamiz.
const RESIZE_OBSERVER_ERROR = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener("error", (e) => {
  if (e.message === RESIZE_OBSERVER_ERROR) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

// PWA: offline-cache va "Home Screen'ga qo'shish" imkoniyatini yoqadi.
// Diqqat: onUpdate berilmasa, yangi deploy qilingan kod eski service
// worker sababli brauzerda ko'rinmay qolaveradi (foydalanuvchi qo'lda
// keshni tozalamaguncha). Shuning uchun yangi versiya aniqlanishi bilan
// darhol faollashtirib, sahifani BIR MARTA avtomatik qayta yuklaymiz —
// foydalanuvchi har doim eng so'nggi versiyada ishlaydi.
let swRefreshing = false;
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (swRefreshing) return;
    swRefreshing = true;
    window.location.reload();
  });
}
